<template>
  <div
    v-for="(phoneNumber, index) in filteredPhoneNumbers"
    :key="index"
    data-testid="customer-phone-number"
  >
    <template v-if="!appConfig.isCompact">Phone: {{ phoneNumber }}</template>
    <template v-else>
      Phone:
      <SoTooltip :text="`Call ${phoneNumber}`">
        <SoLink @click="makeOutboundCall(phoneNumber)">{{
          phoneNumber
        }}</SoLink>
      </SoTooltip>
    </template>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoLink from "@/components/SoLink.vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import { useAppConfigStore } from "@/stores/appConfig"
  import { AwsConnect3pService } from "@/services/AwsConnect3pService"

  export default defineComponent({
    components: {
      SoTooltip,
      SoLink,
    },
    props: {
      phoneNumbers: {
        type: Array as PropType<(string | null)[]>,
        default: null,
      },
    },
    data() {
      return {
        appConfig: useAppConfigStore(),
      }
    },
    computed: {
      filteredPhoneNumbers(): string[] {
        return this.phoneNumbers.filter(
          (phoneNumber): phoneNumber is string => phoneNumber != null,
        )
      },
    },
    methods: {
      makeOutboundCall(phoneNumber: string) {
        AwsConnect3pService.initiateOutboundCall(phoneNumber)
      },
    },
  })
</script>
